import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import {
  getChannelApplyList,
  getUserBaseList,
  auditChannel,
} from "@/api/operation";
import { Button, Form, message, Modal, notification, Space, Tag } from "antd";

import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import { columns } from "./helps";
import { channelLevelAreaTree, areaTree } from "@/api/setting";
import { useCascader } from "@/hooks/useCascader";
import { channelStatusData } from "./helps";

const channelLevelData = [
  {
    label: "省级",
    value: 1,
  },
  {
    label: "市级",
    value: 2,
  },
  {
    label: "区级",
    value: 3,
  },
];

export default function ChannelManager() {
  const dispatch = useDispatch();
  const {
    state: { app_store_type },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);

  const [form] = Form.useForm();

  const [pageData, setPageData] = useState<GetCmsPageHomeRes["rows"]>([]);
  const [total, setTotal] = useState(0);
  const [addProxyOpen, setAddProxyOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [userBaseList, setUserBaseList] = useState<any[]>([]);
  const onceTime = useRef(false);
  const [areaOptions, setAreaOptions] = useState<any[]>([]);
  const initAreaOptions = useRef<any[]>([]);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [modalFormData, setModalFormData] = useState<pageHomeAddParams>({
    status: "0",
    url: [],
  });

  const [formData, setFormData] = useState<any>({
    ypageNum: 1,
    ypageSize: 10,
  });

  const { cascaderProps, loadByIds } = useCascader({
    fetchData: areaTree as any,
    initId: [100000],
  });

  const formTab = [
    {
      label: "渠道等级",
      name: "channelLevel",
      type: "select",
      options: channelLevelData,
    },
    {
      label: "区域范围",
      name: "channelName",
      type: "cascader",
      params: {
        ...cascaderProps,
        style: {
          width: "180px",
        },
      },
    },
    {
      label: "用户账号",
      name: "channelAgentMobile",
      type: "input",
    },

    {
      label: "状态",
      name: "channelStatusList",
      type: "select",
      params: {
        allowClear: false,
        defaultValue: 0,
      },
      options: channelStatusData,
    },
  ];

  const fetchAreaData = async (id: number, level: number) => {
    try {
      if (level === 0) {
        // let areaData = [];
        const { data } = await areaTree(id);
        const { data: level1Data } = (await areaTree(data[0].id)) as any;
        const { data: level2Data } = await areaTree(level1Data[0].id);
        level1Data[0].children = level2Data;
        data[0].children = level1Data;
        console.log(data, "data");
        setAreaOptions(data);
      } else {
        const data = await areaTree(id);
        console.log(data, "data");
      }
    } catch (error) {
      console.error("获取区域数据失败:", error);
    }
  };

  const getUserBaseListData = async (val: string) => {
    if (onceTime.current || !val) {
      return;
    }
    setTimeout(() => {
      onceTime.current = false;
    }, 300);

    onceTime.current = true;

    const { data } = await getUserBaseList({ mobile: val });
    console.log(data, "data");
    setUserBaseList(
      data?.map((item: any) => ({ label: item.nickName, value: item.userId }))
    );
  };

  useEffect(() => {
    // 加载初始数据
    areaTree(100000).then(({ data }) => {
      setAreaOptions(
        data.map((item: any) => ({
          label: item.name,
          value: item.id,
          isLeaf: false, // 初始节点都可以展开
        }))
      );
    });
  }, []);

  const addProxyFormTab = [
    {
      label: "用户昵称",
      name: "channelAgentNickName",
      type: "input",
      rules: [{ required: true, message: "请选择代理人账号" }],
      params: {
        disabled: true,
      },
    },
    {
      label: "用户账号",
      name: "channelAgentMobile",
      type: "input",
      rules: [{ required: true, message: "请选择代理人账号" }],
      params: {
        disabled: true,
      },
    },
    {
      label: "驳回原因",
      name: "rejectReason",
      type: "textArea",
      rules: [{ required: true, message: "请填写驳回原因" }],
    },
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);

  useEffect(() => {
    !app_store_type && dispatch(dictInfoAsync("app_store_type") as any);
  }, []);

  const getPageData = async () => {
    setLoading(true);
    const channelLevel: any = {
      channelCityId: formData.channelName?.[1],
      channelDistrictId: formData.channelName?.[2],
      channelProvinceId: formData.channelName?.[0],
      channelStatusList: [formData.channelStatusList || "0"],
    };
    try {
      const data = await getChannelApplyList({
        ...formData,
        ...channelLevel,
        delFlag: 0,
      });
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      ypageNum: 1,
      ypageSize: 10,
    });
  };
  const resetModal = () => {
    form.resetFields();

    setModalFormData({
      status: "0",
      url: [],
    });
    setAreaOptions([]);
    setUserBaseList([]);
    setOpen(false);
  };

  const confirmProxy = async (values: { rejectReason: any }) => {
    await auditChannel({
      id: modalFormData.id,
      rejectReason: values.rejectReason,
      channelStatus: "2",
    });
    setOpen(false);
    getPageData();

    message.success("驳回成功");
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };
  const passConfirm = async (item: { id: string }) => {
    Modal.confirm({
      title: "提示？",
      content: "确定要通过当前审核吗？",
      onOk: async () => {
        await auditChannel({
          channelStatus: "1",
          id: item.id,
        });
        message.success("审核通过");
        getPageData();

        // notification.success({
        //   message: "审核通过",
        //   placement: "bottomRight",
        // });
      },
    });
  };
  return (
    <div>
      <Modal
        destroyOnHidden
        open={open}
        title={"驳回"}
        width="360px"
        footer={<></>}
        onCancel={() => {
          setOpen(false);
        }}
      >
        <PageTab
          subFoot
          search={confirmProxy}
          reset={() => {
            setOpen(false);
          }}
          initialValues={modalFormData}
          formTab={addProxyFormTab}
        ></PageTab>
      </Modal>

      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={[]}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="id"
        columns={columns({
          setModalFormData,
          setOpen,
          fetchAreaData,
          setAddProxyOpen,
          loadByIds,
          passConfirm,
        })}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
}
